import {IntlShape} from 'react-intl';
import {topicValueToMessages} from './topicMessages';
import type {Topic} from './TopicSelector';

export type TopicOption = {
  value: Topic;
  label: string;
};

export const getTopicOptions = (
  intl: IntlShape,
  topics: ReadonlyArray<Topic>,
): Array<TopicOption> => {
  // TODO(mimi): Update with locale once we have that available
  const locale = 'en-US';

  const options = topics.map((topic) => {
    const optionMessages = topicValueToMessages[topic];
    return {
      value: topic,
      label: intl.formatMessage(optionMessages.label),
    };
  });

  // TODO(mimi): Check if locale is sortable
  const collator = new Intl.Collator(locale);
  options.sort((topicA, topicB) => {
    if (topicA.value === topicB.value) {
      return 0;
    }

    // Force "other" to be at the end, regardless of alphabetical order
    if (topicA.value === 'other') {
      return 1;
    }
    if (topicB.value === 'other') {
      return -1;
    }

    return collator.compare(topicA.label, topicB.label);
  });

  return options;
};
